import React, { Component } from 'react';
import update from 'immutability-helper';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import { PatientAPIConnectors } from '../../api/index';
import InputFile from '../../components/shared/InputFile';

class UploadWoundPhotoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preview: {
        file: null,
        src: '',
        isVisible: false,
      },
    };

    this.onSelectFile = this.onSelectFile.bind(this);
    this.cancel = this.cancel.bind(this);
    this.upload = this.upload.bind(this);
  }

  onSelectFile(file) {
    this.createImage(file);
  }

  cancel(e) {
    e.preventDefault();
    /**
     *  back to previous path
     *  TODO: react-router's Link Component should remember the previous path
     *  http://stackoverflow.com/questions/3528324/how-do-you-get-the-previous-url-in-javascript
     */
    window.location.href = document.referrer || `/medical-records/${this.props.medicalRecordId}`;
  }

  upload(e) {
    e.preventDefault();
    // upload photo
    const uploadPromise = this.uploadImage.uploadWrapper(
      PatientAPIConnectors.uploadAssessmentPhoto, this.props.assessmentId
    );

    uploadPromise
      .then(() => {
        window.location.href = document.referrer || `/medical-records/${this.props.medicalRecordId}`;
        this.props.actions.createSuccessAlert(i18n.t('uploadSucceedMsg'));
      })
      .finally(() => {});
    return false;
  }

  createImage(file) {
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        preview: update(this.state.preview, {
          file: { $set: file },
          src: { $set: reader.result },
          isVisible: { $set: true },
        }),
      });
    };
    reader.readAsDataURL(file);
  }

  render() {
    return (
      <div className="well center col-lg-8 col-lg-offset-2">
        <form className="form-horizontal">
          <fieldset>
            <legend>
              {i18n.t('newWound')}
            </legend>
            <div className="avatarContainer">
              { this.state.preview.src === ''
                ? null
                : (
                  <img
                    alt={i18n.t('avatar')}
                    src={this.state.preview.src}
                    className="img-rounded img-responsive center-block"
                  />
                )
              }
              <InputFile
                actions={this.props.actions}
                ref={(ref) => { this.uploadImage = ref; }}
                onSelectFile={this.onSelectFile}
                id={'files'}
                className={'hidden'}
              />
            </div>
            <label htmlFor="files">
              <u>
                {i18n.t('selectFile')}
              </u>
            </label>
          </fieldset>
          <div className="row">
            <div className="col-lg-5 center-block" style={{ float: 'none' }}>
              <button
                className="btn btn-primary"
                onClick={this.upload}
              >
                {i18n.t('upload')}
              </button>
              <button
                className="btn btn-default"
                onClick={this.cancel}
              >
                {i18n.t('cancel')}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default connectActionsAndReducers(UploadWoundPhotoContainer);



// WEBPACK FOOTER //
// ./src/containers/patient/UploadWoundPhotoContainer.js